module.exports = __webpack_public_path__ + "img/challenge_progress_bg.de077d5e.png";